import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Footer, LegalInfo, Navbar } from '../components/comp';
import {
  About,
  Admin,
  Auth,
  Blog,
  Career,
  Contact,
  ErrorPage,
  Faqs,
  Home,
  Policies,
  Services,
} from '../pages/page';
const RouterNavigation = () => {
  const [admin, setAdmin] = useState(false);
  return (
    <>
      {!admin && <Navbar />}
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route
          path="/auth"
          element={<Auth myAdmin={setAdmin} />}
          className={!admin ? 'hide' : ''}
        />
        <Route path="/abs_panel" element={<Admin myAdmin={setAdmin} />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/career" element={<Career />} />
        <Route path="/detail-career/:id" element={<Career />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/legal-info" element={<LegalInfo />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      {!admin && <Footer myAdmin={setAdmin} />}
    </>
  );
};

export default RouterNavigation;
